import { useBreakpoints } from './use-breakpoints';
/**
 * Resolves the `size` a Modern Famly input or control should render at.
 *
 * An explicit `size` always wins. Without one, the size follows the viewport: `'compact'` from
 * tablet portrait up, where pointer density is what matters, and `'regular'` below it, where the
 * larger touch target is easier to hit.
 *
 * Every Modern Famly input and control defaults through here, so changing the breakpoint or the
 * sizes it maps to restyles controls on every screen in the product at once.
 *
 * @param sizeFromProps - The `size` the caller passed, if any.
 * @returns The caller's size, or the viewport-appropriate one when the caller gave none.
 *
 * @example
 * ```tsx
 * const MyControl = ({size: sizeFromProps}: MyControlProps) => {
 *     const size = useResponsiveSize(sizeFromProps);
 *     return <Something size={size} />;
 * };
 * ```
 */
export const useResponsiveSize = (sizeFromProps) => {
    const { isTabletPortraitAndLarger } = useBreakpoints();
    return sizeFromProps !== null && sizeFromProps !== void 0 ? sizeFromProps : (isTabletPortraitAndLarger ? 'compact' : 'regular');
};
